import { useParams } from 'react-router-dom';

import { useContactsGroupQuery } from '@dashboard/generated/wp/platform';

export default function useCurrentContactsGroup() {
  const id = useParams<{ id: string }>().id!;
  return useContactsGroupQuery({ variables: { id } });
}
